import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";

import * as styles from "./styles.module.css";

/**
 * SingleQuote component
 * @param {Object} data - The data for the slider
 * @returns {JSX.Element} - Rendered SingleQuote component
 */
const SingleQuote = ({ data }) => {
    const { cardItem, additionalConfiguration, backgroundColor, backgroundImage, customId } = data ?? {};
    const { title, body, subtitle } = cardItem ?? {};
    const spacingClassNames = getSpacingClassName(additionalConfiguration, "py-15 md:py-30");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section className={`${spacingClassNames} ${sectionColorMapping.bgColor}`} id={customId}>
            <div className="relative">
                <div className="container">
                    <div className="row">
                        <div>
                            <div
                                className={`bg-blue h-full  rounded-sm p-10 bg-no-repeat bg-right  bg-blend-color-dodge min-h-[251px]  ${styles.background}`}
                                style={{
                                    backgroundImage: `url(${
                                        backgroundImage?.length > 0 ? backgroundImage?.[0]?.secure_url : "none"
                                    })`,
                                }}
                            >
                                <div className="flex flex-col h-full justify-between   gap-15 ">
                                    <div>
                                        {body?.raw && (
                                            <blockquote
                                                className={`text-white font-semibold indent-1.25 ${styles.description}`}
                                            >
                                                {documentToReactComponents(JSON.parse(body.raw))}
                                            </blockquote>
                                        )}
                                    </div>
                                    <div className="flex flex-col">
                                        {title && (
                                            <span className="text-white  text:base md:text-xl font-semibold leading-tight  tracking-normal">
                                                {title}
                                            </span>
                                        )}
                                        {subtitle && (
                                            <div className="text-white">
                                                <span className="text-white text-xs md:text-sm font-normal">
                                                    {subtitle}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SingleQuote;
